const SpecialBuildings = {
    stove: {
        name: "熔炉",
        resources: {
            "": "无",
            copperIngot: "铜锭",
            ironIngot: "铁锭"
        }
    }
}
export default SpecialBuildings